import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { BsCreditCard2BackFill } from 'react-icons/bs';
import { RiMoneyDollarBoxLine } from 'react-icons/ri';
import { checkDataIsValid } from '../../utils/secure';
import { useTranslation } from '../../Context/LanguageContext';

const PaymentInformation = (props) => {
  const { totalFee } = props;
  const { invoiceAmt, additionalAmt } = props.values || {};
  const { t } = useTranslation();

  return (
    <>
      <div className='card mb-4'>
        <div className='card-header pb-0 px-3'>
          <h3 className='mb-0 text-center' style={{ color: 'var(--text-primary)' }}>{t('paymentInformation')}</h3>
        </div>
        <div className='card-body pt-4 p-3'>
          <div className='row'>
            <div className='col-12'>
              <h6 style={{ color: 'var(--text-primary)' }}>{t('amountToTransfer')}</h6>
              <div className='d-flex justify-content-between align-items-center'>
                <div>
                  <div>
                    <span
                      className='btn bg-gradient-dark'
                      id='navbarDropdownMenuLink2'
                    >
                      <img src='https://demos.creative-tim.com/argon-dashboard-pro-bs4/assets/img/icons/flags/US.png' />{' '}
                      USD
                    </span>
                  </div>
                </div>
                <h3 className='text-end' style={{ color: 'var(--text-primary)' }}>
                  {invoiceAmt ? parseFloat(invoiceAmt).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}
                </h3>
              </div>
              <div className='d-flex justify-content-between'>
                <h6 style={{ color: 'var(--text-primary)' }}>{t('invoiceAmount')}</h6>
                <h5 className='text-end' style={{ color: 'var(--text-primary)' }}>
                  {invoiceAmt ? parseFloat(invoiceAmt).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}
                </h5>
              </div>
              <div className='d-flex justify-content-between'>
                <h6 style={{ color: 'var(--text-primary)' }}>{t('transactionFees')}</h6>
                <div className='text-end'>
                  <h5 style={{ color: 'var(--text-primary)' }}>
                    {additionalAmt ? parseFloat(additionalAmt).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}
                  </h5>
                  <p style={{ color: 'var(--text-primary)' }}>{t('paidByYou')}</p>
                </div>
              </div>
              <div className='d-flex justify-content-between'>
                <h6 style={{ color: 'var(--text-primary)' }}>{t('total')}</h6>
                <h5 className='text-end' style={{ color: 'var(--text-primary)' }}>
                  {totalFee ? parseFloat(totalFee).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}
                </h5>
              </div>
            </div>
            <div className='col-12'>
              <ul className='ps-3' style={{ color: 'var(--text-primary)' }}>
                <li>
                  {t('paymentInfo1')}
                </li>
                <li>
                  {t('paymentInfo2')}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentInformation;
